<template>
  <div class="col-md-12 center">
    <div class="add_mg">
      <select
        id="select_strategy"
        v-model="strategy"
        v-on:change="changeStrategy($event)"
        class="selectpicker"
      >
        <option value="0">ยุทธศาสตร์ชาติ</option>
        <option value="1">ยุทธศาสตร์ชาติด้านความมั่นคง</option>
        <option value="2">ยุทธศาสตร์ชาติด้านการสร้างความสามารถในการแข่งขัน</option>
        <option value="3">ยุทธศาสตร์ด้านการพัฒนาและเสริมสร้างศักยภาพมนุษย์</option>
        <option value="4">ยุทธศาสตร์ชาติด้านการสร้างโอกาสและความเสมอภาคทางสังคม</option>
        <option value="5">ยุทธศาสตร์ชาติด้านการสร้างการเติบโตบนคุณภาพชีวิตที่เป็นมิตรต่อสิ่งแวดล้อม</option>
        <option value="6">ยุทธศาสตร์ชาติด้านการปรับสมดุลและพัฒนาระบบการบริหารจัดการภาครัฐ</option>
      </select>
      &nbsp;&nbsp;&nbsp;
      <select
        id="select_reform"
        v-on:change="changeReform($event)"
        class="selectpicker"
      >
        <option value="0">แผนปฏิรูปประเทศ</option>
        <option value="1">แผนการปฏิรูปประเทศด้านการเมือง</option>
        <option value="2">แผนการปฏิรูปประเทศด้านการบริหารราชการแผ่นดิน</option>
        <option value="3">แผนการปฏิรูปประเทศด้านกฎหมาย</option>
        <option value="4">แผนการปฏิรูปประเทศด้านกระบวนการยุติธรรม</option>
        <option value="5">แผนการปฏิรูปประเทศด้านเศรษฐกิจ</option>
        <option value="6">แผนการปฏิรูปประเทศด้านทรัพยากรธรรมชาติและสิ่งแวดล้อม</option>
        <option value="7">แผนการปฏิรูปประเทศด้านสาธารณสุข</option>
        <option value="8">แผนการปฏิรูปประเทศด้านสื่อสารมวลชน เทคโนโลยีสารสนเทศ</option>
        <option value="9">แผนการปฏิรูปประเทศด้านสังคม</option>
        <option value="10">แผนการปฏิรูปประเทศด้านพลังงาน</option>
        <option value="11">แผนการปฏิรูปประเทศด้านการป้องกันและปราบปรามการทุจริตและประพฤติมิชอบ</option>
        <option value="12">แผนการปฏิรูปประเทศด้านการศึกษา</option>
      </select>
      &nbsp;&nbsp;&nbsp;
      <select
        id="select_masterplan"
        v-on:change="changeMasterplan($event)"
        class="selectpicker"
      >
        <option value="0">แผนแม่บทภายใต้ยุทธศาสตร์ชาติ</option>
        <option value="1">ความมั่นคง</option>
        <option value="2">การต่างประเทศ</option>
        <option value="3">การเกษตร</option>
        <option value="4">อุตสาหกรรมและบริการแห่งอนาคต</option>
        <option value="5">การท่องเที่ยว</option>
        <option value="6">พื้นที่และเมืองน่าอยู่อัจฉริยะ</option>
        <option value="7">โครงสร้างพื้นฐาน ระบบโลจิสติกส์ และดิจิทัล</option>
        <option value="8">ผู้ประกอบการและวิสาหกิจขนาดกลางและขนาดย่อมยุคใหม่</option>
        <option value="9">เขตเศรษฐกิจพิเศษ</option>
        <option value="10">การปรับเปลี่ยนค่านิยมและวัฒนธรรม</option>
        <option value="11">การพัฒนาศักยภาพคนตลอดช่วงชีวิต</option>
        <option value="12">การพัฒนาการเรียนรู้</option>
        <option value="13">การเสริมสร้างให้คนไทยมีสุขภาวะที่ดี</option>
        <option value="14">ศักยภาพการกีฬา</option>
        <option value="15">พลังทางสังคม</option>
        <option value="16">เศรษฐกิจฐานราก</option>
        <option value="17">ความเสมอภาคและหลักประกันทางสังคม</option>
        <option value="18">การเติบโตอย่างยั่งยืน</option>
        <option value="19">การบริหารจัดการน้ำทั้งระบบ</option>
        <option value="20">การบริการประชาชนและประสิทธิภาพภาครัฐ</option>
        <option value="21">การต่อต้านการทุจริตและประพฤติมิชอบ</option>
        <option value="22">กฎหมายและกระบวนการยุติธรรม</option>
        <option value="23">การวิจัยและพัฒนานวัตกรรม</option>
      </select>
    </div>
  </div>
</template>
<script>
import $ from "jquery";

export default {
  data: function() {
    return { strategy: 0 };
  },
  methods: {
    changeStrategy: function changeStrategy(event) {
      if (event.target.value > 0) {
        $("#select_reform").val(0);
        $("#select_masterplan").val(0);
        $(".selectpicker").selectpicker("refresh");
        this.$router.push({
          name: "strategy",
          params: { id: event.target.value }
        });
      } else {
        this.$router.push({
          name: "home"
        });
      }
    },
    changeReform: function changeReform(event) {
      if (event.target.value > 0) {
        $("#select_strategy").val(0);
        $("#select_masterplan").val(0);
        $(".selectpicker").selectpicker("refresh");

        this.$router.push({
          name: "reform",
          params: { id: event.target.value }
        });
      } else {
        this.$router.push({
          name: "home"
        });
      }
    },
    changeMasterplan: function changeMasterplan(event) {
      if (event.target.value > 0) {
        $("#select_strategy").val(0);
        $("#select_reform").val(0);
        $(".selectpicker").selectpicker("refresh");
        this.$router.push({
          name: "masterplan",
          params: { id: event.target.value }
        });
      } else {
        this.$router.push({
          name: "home"
        });
      }
    }
  }
};
</script>
<style>
.bootstrap-select:not([class*="col-"]):not([class*="form-control"]):not(.input-group-btn) {
  width: 300px !important;
}
</style>
